<script setup lang="ts">
import { defineProps, ref } from 'vue'
import { type Activity } from '@/api-swagger'
import ActivityEdit from '@/components/features/activities/ActivityEdit.vue'

defineProps({
  activity: {
    type: Object as () => Activity,
    required: true,
  },
})

const openModal = ref<boolean>(false)
</script>

<template>
  <div
    class="rounded-xl flex w-full p-2 my-3"
    style="background-color: #c9f5f0"
    @click="openModal = true"
  >
    <div class="flex flex-col w-0 divider divider-horizontal divider-accent"></div>
    <div class="flex flex-col">
      <p class="text-lg">
        {{ activity.summary }}
      </p>
    </div>
  </div>
  <activity-edit
    v-if="openModal"
    :show-modal="true"
    :activity="activity"
    :user-id="activity.userId.id"
    @close="openModal = false"
  ></activity-edit>
</template>
